import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en/en';
import ko from './locales/ko/ko';

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ko: { translation: ko },
  },
  lng: 'en', // 기본 언어 설정
  fallbackLng: 'ko', // 번역이 없을 경우 사용할 언어
  interpolation: {
    escapeValue: false,
  },
});

// 언어 변경 시 폰트 업데이트
i18n.on('languageChanged', (lng) => {
  const fontFamily = lng === 'ko' ? "'Suit medium', sans-serif" : "'Inter medium', sans-serif";
  document.documentElement.style.setProperty('--font-family', fontFamily);
});

// 초기 폰트 설정
const initialFont = i18n.language === 'ko' ? "'Suit medium', sans-serif" : "'Inter medium', sans-serif";
document.documentElement.style.setProperty('--font-family', initialFont);

export default i18n;
